import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getIsCommentsLoading } from '../../selectors/is-loading-selectors';
import { getCommentsByPostId, getCommentsByPostIdAndPage } from '../../selectors/comment-selectors';
import { getEntityCount } from '../../selectors/pagination-selectors';
import { getEditedCommentId } from '../../selectors/edited-comment-id-selectors';
import { incrementCommentLikeCount } from '../../actions/increment-comment-like-count';
import { setIsLoaded } from '../../actions/set-is-loaded';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPostBySlug } from '../../selectors/post-selectors';
import LoadMore from '../../components/load-more';
import Loader from '../../components/loader';
import CommentList from '../../components/comment-list';
import withDeviceType from '../../hoc/with-device-type';
import _ from 'lodash';

export class PostCommentList extends Component {
  componentWillUnmount = () => {
    this.props.setIsLoaded('comments', this.props.postId, false);
  };

  render = () => {
    const { allComments, currentPageComments, isCommentsLoading, entityCount, isMobile } = this.props;
    if (!allComments.length) {
      return null;
    }

    if (isMobile) {
      return (
        <LoadMore
          loadMore={this.props.loadMore}
          loader={<Loader/>}
          isLoading={isCommentsLoading}
          hasMore={allComments.length < entityCount}
        >
          {this.renderCommentList(allComments)}
        </LoadMore>
      );
    }

    if (currentPageComments.length) {
      return this.renderCommentList(currentPageComments);
    }

    return null;
  };

  renderCommentList = comments => {
    const { incrementCommentLikeCount, editedCommentId, topCommentId } = this.props;
    return (
      <CommentList
        reportBottomPosition={this.props.setFirstCommentBottomPosition}
        comments={comments}
        onLikeClick={incrementCommentLikeCount}
        editedCommentId={editedCommentId}
        topCommentId={topCommentId}
      />
    );
  };
}

PostCommentList.propTypes = {
  editedCommentId: PropTypes.string,
  topCommentId: PropTypes.string,
  allComments: PropTypes.array.isRequired,
  currentPageComments: PropTypes.array.isRequired,
  entityCount: PropTypes.number,
  postId: PropTypes.string,
  isMobile: PropTypes.bool,
  isCommentsLoading: PropTypes.bool,
  setIsLoaded: PropTypes.func,
  loadMore: PropTypes.func,
  incrementCommentLikeCount: PropTypes.func.isRequired,
  setFirstCommentBottomPosition: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const post = getPostBySlug(state, ownProps.postSlug) || {};
  const page = ownProps.page;
  return {
    isCommentsLoading: getIsCommentsLoading(state, ownProps.postSlug),
    currentPageComments: getCommentsByPostIdAndPage(state, post._id, page),
    allComments: getCommentsByPostId(state, post._id),
    entityCount: getEntityCount(state, 'comments'),
    editedCommentId: getEditedCommentId(state),
    topCommentId: post.topCommentId,
    postId: post._id,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      incrementCommentLikeCount,
      setIsLoaded,
    },
    dispatch
  );

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps), withDeviceType)(PostCommentList);



// WEBPACK FOOTER //
// ./app/containers/post-comment-list/post-comment-list.js